/* eslint-disable @stylistic/indent */

const commonCustomMeta = function () {
    // common head
    useHead({
        link: [
            { rel: 'canonical', href: '' },
            { rel: 'dns-prefetch', href: 'https://gvs.weathernews.jp/' },
            { rel: 'dns-prefetch', href: 'https://gis.weathernews.jp' },
            { rel: 'dns-prefetch', href: 'https://site.weathernews.jp' }
        ],
        meta: [
            { name: 'wntouch_ch', content: '服装予報' },
            { name: 'wntouch_icon', content: 'https://smtgvs.cdn.weathernews.jp/ip/myweather/img/icon_clothes@2x.png' },
            { name: 'wntouch_icon_gray', content: 'https://smtgvs.cdn.weathernews.jp/ip/myweather/img/icon_clothes_trans@2x.png' },
            { name: 'wntouch_icon_setting', content: 'https://smtgvs.cdn.weathernews.jp/ip/tabmenu/icon/icon_clothes@2x.png' }
        ]
    })
    // common set meta
    useSeoMeta({
        ogImage: 'https://gvs.weathernews.jp/clothes/images/SNSclothes.png',
        ogType: 'website',
        ogSiteName: 'ウェザーニュース',
        viewport: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=3.0,user-scalable=yes',
        twitterCard: 'summary_large_image',
        twitterSite: '@wni_jp',
        twitterCreator: '@wni_jp',
        twitterImage: 'https://gvs.weathernews.jp/clothes/images/SNSclothes.png',
        fbAppId: '1500388770270212',
        appleItunesApp: 'app-id=302955766',
        appleMobileWebAppCapable: 'yes'
    })
}

export const useCustomMetaTopics = function () {
    commonCustomMeta()
    const ROUTE = useRoute()
    const CONFIG = useRuntimeConfig()
    const BASE_URL = `${CONFIG.public.HOST_DOMAIN}${CONFIG.app.baseURL}`
    const pageURL = `${BASE_URL}${ROUTE.path.replace(/^\//, '')}`
    const title = '服装に関するトピックス - ウェザーニュース'
    const description = '【服装トピックス】季節に合わせた服装選びのコツを解説。春夏秋冬それぞれの気温や気候に適した着こなし方、コーディネート例を紹介。毎日の服選びをサポートします。季節の変わり目の対応策や、気象変化に対応するレイヤードテクニックも必見です。'
    useSeoMeta({
        title: title,
        description: description,
        ogTitle: title,
        ogDescription: description,
        ogUrl: pageURL,
        appleMobileWebAppTitle: title,
        keywords: `服装,ニュース`
    })
    // wntouch
    useHead({
        meta: [{ name: 'wntouch_enable', content: 'no' }]
    })
}

export const useCustomMetaPoint = function (seoInfo) {
    const pointName = seoInfo.pointName
    const pageType = seoInfo.type || 'point'

    const ROUTE = useRoute()
    const CONFIG = useRuntimeConfig()
    const BASE_URL = `${CONFIG.public.HOST_DOMAIN}${CONFIG.app.baseURL}`
    const pageURL = `${BASE_URL}${ROUTE.path.replace(/^\//, '')}`
    const titleInfo = {
        top: '服装予報｜今日、何着る？ - ウェザーニュース',
        area: `${pointName}の服装予報｜今日、何着る？ - ウェザーニュース`,
        point: `${pointName}の服装予報｜今日、何着る？ - ウェザーニュース`
    }
    const descriptionInfo = {
        top: '【今日明日の服装予報】天気と体感の予報から朝晩と昼間の寒暖差に対応した最適な服装を提案します。10日先までの天気予報と連動した服装予報で、旅行や出張の準備も安心です。季節の変わり目の悩みも解決！今すぐチェックして快適な毎日を。',
        area: `【${pointName}｜今日明日の服装予報】天気と体感の予報から朝晩と昼間の寒暖差に対応した最適な服装を提案します。10日先までの天気予報と連動した服装予報で、旅行や出張の準備も安心です。季節の変わり目の悩みも解決！今すぐチェックして快適な毎日を。`,
        point: `【${pointName}｜今日明日の服装予報】あなたの現在地や指定地点での天気と体感の予報から朝晩・昼間別に最適な服装を提案します。季節の変わり目や旅行の荷造りに便利な10日先までの服装予報で、毎日のコーディネートをサポート。「今日は何を着ればいい？」という悩みを解決します。`
    }

    const keywordsInfo = {
        top: '服装予報,ウェザーニュース',
        area: `${pointName},服装,今日`,
        point: `${pointName},服装,今日`
    }

    commonCustomMeta()
    useSeoMeta({
        title: titleInfo[pageType],
        description: descriptionInfo[pageType],
        ogTitle: titleInfo[pageType],
        ogDescription: descriptionInfo[pageType],
        ogUrl: pageURL,
        appleMobileWebAppTitle: titleInfo[pageType],
        keywords: keywordsInfo[pageType]
    })

    // wntouch
    if (seoInfo?.wntouch) {
        const touchPointName = (pointName) ? pointName : '全国'
        useHead({
            meta: [
                { name: 'wntouch_enable', content: 'yes' },
                { name: 'wntouch_title', content: `${touchPointName}の服装予報` },
                { name: 'wntouch_count', content: 'clothes' }, // TODO
                { name: 'wntouch_url', content: pageURL }
            ]
        })
    } else {
        useHead({
            meta: [{ name: 'wntouch_enable', content: 'no' }]
        })
    }
}
